import { get } from 'lodash';

import fetchAction from 'utils/fetchAction';

import { config } from 'api';
import { Url } from 'lib/utils/url';

import { buildPromosLinks } from '../service/promosLinkBuilder';

export const SUB_NAVIGATION_REQUEST = 'SUB_NAVIGATION_REQUEST';
export const SUB_NAVIGATION_SUCCESS = 'SUB_NAVIGATION_SUCCESS';
export const SUB_NAVIGATION_ERROR = 'SUB_NAVIGATION_ERROR';

export const SET_SUB_NAV_CATEGORY_IDS = 'SET_SUB_NAV_CATEGORY_IDS';
export const SET_BROWSE_SHOP_NAV_CATEGORY_IDS = 'SET_BROWSE_NAV_CATEGORY_IDS';
export const UPDATE_PROMO_LINKS = 'UPDATE_PROMO_LINKS';

export function setSubNavCategoryIds(categoryIds) {
  return {
    type: SET_SUB_NAV_CATEGORY_IDS,
    categoryIds,
  };
}

export function setBrowseShopNavCategoryIds(categoryIds) {
  return {
    type: SET_BROWSE_SHOP_NAV_CATEGORY_IDS,
    categoryIds,
  };
}

export function computePromosNavigationLinks() {
  return {
    type: UPDATE_PROMO_LINKS,
    promos: buildPromosLinks(),
  };
}

const mapRouteToCatalogueType = (route) => {
  switch (route.basePath) {
    case '/on-offer': return 'OFFER_PRODUCTS';
    case '/regulars': return 'SUBSCRIPTIONS';
    case '/coupons': return 'COUPONS';
    case '/your-savings-hub': return 'SAVINGS_HUB';
    default: return 'SHOP';
  }
};

const getSubNavigationURLParams = (getState, route) => {
  const catalogueType = mapRouteToCatalogueType(route);
  const currentProductsPage = getState().catalogue.productsPagesByRoute[route.toString()] || {};

  const { pageParameters = {} } = currentProductsPage;

  const {
    campaigns = [],
    category = [],
    customFilters = [],
    filters = [],
    priceFilters = [],
  } = pageParameters;

  const tags = category.concat(filters);
  const urlParams = {
    catalogueType,
    tags: tags.map(tag => tag.id).join(','),
    filters: customFilters.map(tag => tag.id).join(','),
    price: priceFilters.map(priceFilter => `${priceFilter.from}-${(priceFilter.to || '')}`).join(','),
  };

  if (campaigns.length) {
    urlParams.campaigns = campaigns.map(campaign => campaign.id).join(',');
  }
  return urlParams;
};

export function getSubNavigationURL(getState, route, opts = {}) {
  const { basePathSuffix = '' } = opts;
  const url = get(route, 'apiBasePaths.navigationApi', `${config.apiBasePath}${basePathSuffix}/subnavigation`);
  const urlParams = getSubNavigationURLParams(getState, route);

  return new Url(url).addQueryParameters(urlParams).toString();
}

export const loadCatalogueSubNavigation = fetchAction({
  actions: [
    SUB_NAVIGATION_REQUEST,
    SUB_NAVIGATION_SUCCESS,
    SUB_NAVIGATION_ERROR,
  ],
  url: (getState, requestParams, { route }) => getSubNavigationURL(getState, route),
});

export const loadCouponsSubNavigation = fetchAction({
  actions: [
    SUB_NAVIGATION_REQUEST,
    SUB_NAVIGATION_SUCCESS,
    SUB_NAVIGATION_ERROR,
  ],
  url: (getState, requestParams, { route }) => getSubNavigationURL(getState, route, {
    basePathSuffix: '/coupons',
  }),
});
